// Textes de notification pour le système de barres de notification globales
export const NOTIFICATION_TEXTS = {
  // Titres par défaut pour les types de notification
  defaultTitles: {
    success: 'Succès',
    error: 'Erreur',
    warning: 'Avertissement',
    info: 'Information',
    default: 'Notification'
  },

  // Titres génériques (conservés pour compatibilité)
  titles: {
    success: 'Succès',
    error: 'Erreur',
    warning: 'Avertissement',
    info: 'Information',
    notification: 'Notification'
  },

  // Messages de succès communs
  success: {
    createSuccess: 'Élément créé avec succès',
    updateSuccess: 'Élément modifié avec succès',
    deleteSuccess: 'Élément supprimé avec succès',
    saveSuccess: 'Modifications enregistrées avec succès',
    uploadSuccess: 'Fichier téléchargé avec succès',
    exportSuccess: 'Données exportées avec succès',
    copySuccess: 'Copié dans le presse-papiers',
    connectionSuccess: 'Connexion réussie'
  },

  // Messages d'erreur communs
  error: {
    createFailed: 'Échec de la création de l\'élément',
    updateFailed: 'Échec de la modification de l\'élément',
    deleteFailed: 'Échec de la suppression de l\'élément',
    saveFailed: 'Échec de l\'enregistrement des modifications',
    loadFailed: 'Échec du chargement des données',
    uploadFailed: 'Échec du téléchargement du fichier',
    exportFailed: 'Échec de l\'exportation des données',
    connectionFailed: 'Échec de la connexion',
    networkError: 'Erreur réseau survenue',
    unknownError: 'Une erreur inattendue s\'est produite',
    permissionDenied: 'Permission refusée',
    invalidData: 'Données invalides fournies'
  },

  // Messages d'avertissement communs
  warning: {
    unsavedChanges: 'Vous avez des modifications non enregistrées',
    dataOutdated: 'Les données peuvent être obsolètes',
    connectionIssue: 'Problème de connexion détecté',
    storageLimit: 'Limite de stockage approchée',
    batteryLow: 'Niveau de batterie faible',
    configurationIssue: 'Problème de configuration détecté'
  },

  // Messages d'information communs
  info: {
    dataUpdated: 'Les données ont été mises à jour',
    newDataAvailable: 'De nouvelles données sont disponibles',
    systemMaintenance: 'Maintenance système programmée',
    featureNotAvailable: 'Fonctionnalité non disponible',
    processingInProgress: 'Traitement en cours',
    refreshRequired: 'Actualisation requise'
  },

  // Messages spécifiques aux entités
  entities: {
    sensor: {
      created: 'Capteur créé avec succès',
      updated: 'Capteur modifié avec succès',
      deleted: 'Capteur supprimé avec succès',
      moved: 'Capteur déplacé avec succès',
      createFailed: 'Échec de la création du capteur',
      updateFailed: 'Échec de la modification du capteur',
      deleteFailed: 'Échec de la suppression du capteur',
      moveFailed: 'Échec du déplacement du capteur',
      dataExported: 'Données du capteur exportées avec succès',
      dataExportFailed: 'Échec de l\'exportation des données du capteur'
    },
    alert: {
      created: 'Alerte créée avec succès',
      updated: 'Alerte modifiée avec succès',
      deleted: 'Alerte supprimée avec succès',
      createFailed: 'Échec de la création de l\'alerte',
      updateFailed: 'Échec de la modification de l\'alerte',
      deleteFailed: 'Échec de la suppression de l\'alerte'
    },
    location: {
      created: 'Emplacement créé avec succès',
      updated: 'Emplacement modifié avec succès',
      deleted: 'Emplacement supprimé avec succès',
      createFailed: 'Échec de la création de l\'emplacement',
      updateFailed: 'Échec de la modification de l\'emplacement',
      deleteFailed: 'Échec de la suppression de l\'emplacement'
    },
    user: {
      created: 'Utilisateur créé avec succès',
      updated: 'Utilisateur modifié avec succès',
      deleted: 'Utilisateur supprimé avec succès',
      createFailed: 'Échec de la création de l\'utilisateur',
      updateFailed: 'Échec de la modification de l\'utilisateur',
      deleteFailed: 'Échec de la suppression de l\'utilisateur',
      passwordChanged: 'Mot de passe modifié avec succès',
      passwordChangeFailed: 'Échec de la modification du mot de passe'
    }
  }
} as const;